<template>
  <footer :class="['footer__component']">
    <div class="footer__copyright" v-if="hostname === 'www.xesmall.com'">
      <p>
        <span>地址：广州市天河区花城大道18号建滔广场 ｜ </span>
        <span> <a href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备2021123335号</a> ｜ </span>
        <span>Copyright © 2023 ｜ </span>
        <span>广东省唯爱培思线上非学科培训学校有限公司 版权所有 ｜ </span>
        <img src="https://editor.xesimg.com/tailor/resource/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87-1708326074034.png" alt="" srcset="">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44010602012375" rel="noreferrer" target="_blank">粤公网安备44010602012375</a>
      </p>
      <p>
        <span> <a href="https://static0.xesimg.com/gz-luodiye/唯爱章程.pdf" rel="noreferrer" target="_blank">广东省唯爱培思线上非学科培训学校有限公司章程</a> ｜ </span>
        <span> <a href="https://h5.xueersi.com/647e9dd6c39e37c802574f63.html" rel="noreferrer" target="_blank">资质证照公示</a> ｜ </span>
        <span> <a href="https://app.xueersi.com/advance/teaching-pc/" rel="noreferrer" target="_blank">教师信息公示</a> ｜ </span>
        <span>客服联系方式：xessy@tal.com ｜ </span>
        <span>违法/不良信息举报电话：18688393109</span>
      </p>
      <p>
        <span> <a href="https://h5.xueersi.com/64b8f130b6c77ecb00d08fa8.html" rel="noreferrer" target="_blank">学而思素养用户协议&收费标准</a> ｜ </span>
        <span> <a href="https://h5.xueersi.com/64b8ee816caad3bc00efcde7.html" rel="noreferrer" target="_blank">用户个人信息保护政策</a> ｜ </span>
        <span> <a href="https://h5.xueersi.com/64b8f43ec39e37c8025752ac.html" rel="noreferrer" target="_blank">中小学生校外培训服务合同</a> ｜ </span>
        <span> <a href="https://h5.xueersi.com/64b8f0c1bf84d5c2008bcb82.html" rel="noreferrer" target="_blank">儿童个人信息保护规则</a> ｜ </span>
        <span> <a href="https://haoda.100tal.com/app/681b38cb38092ae212bfa1bb/page_k3hfrs" rel="noreferrer" target="_blank">广东省唯爱培思线上非学科培训学校有限公司招生简章</a></span>
      </p>
    </div>
    <div class="footer__copyright" v-else-if="hostname === 'www.vocabularya-z.com.cn'">
      <p>
        <span>广州市唯爱培思网络科技有限公司西安分公司 版权所有 ｜ </span>
        <span>地址：陕西省西安市新城区解放路171号民生大厦1层105室、2层206室 ｜ </span>
        <span>联系电话: 10101985 ｜ </span>
        <img src="https://editor.xesimg.com/tailor/resource/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87-1708326074034.png" alt="" srcset="">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=61010202000381" rel="noreferrer" target="_blank">陕公网安备61010202000381</a>
        <span>Copyright © 2024</span>
      </p>
    </div>
    <div class="footer__copyright" v-if="hostname === 'www.ifutureteachers.com.cn'">
      <p>
        <span> <a href="https://beian.miit.gov.cn/#/Integrated/index">鲁ICP备2023019206号-2</a> ｜ </span>
        <span>Copyright © 2024 ｜ </span>
        <span>山东省济南市市中区二环南路6636号中海广场2606   版权所有 ｜ </span>
        <img src="https://editor.xesimg.com/tailor/resource/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87-1708326074034.png" alt="" srcset="">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=37010302001497" rel="noreferrer" target="_blank">鲁公网安备37010302001497</a>
      </p>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

const hostname = ref(window.location.hostname);

</script>

<style lang="sass" scoped>
.footer__component {
  width: 100%;
  background-color: #333333;
  * {
    color: #999999;
  }
  padding: 50px 0;
  font-size: 12px;
  text-align: center;
}

.footer__component p {
  color: #d0d0d0;
  -webkit-margin-before: -0.2em;
  -webkit-margin-after: 1em;
  -webkit-margin-start: 0px;
  -webkit-margin-end: 0px;
  margin-top: -0.2em;
  margin-bottom: 1em;
  margin-right: 0;
  margin-left: 0;
}

.footer__component p a {
  text-decoration: none;
  color: #d0d0d0;
}

.footer__component p span {
  margin: 0 3px;
}

.footer__component .footer__copyright {
  .telphone,
  .link {
    color: #f13232;
  }
  img{
    width: 14px;
    height: 14px;
    margin-left: 5px;
    margin-right: 5px;
    position: relative;
    top: 2px;
  }
  .footer-copyright__link {
    a {
      margin-left: 5px;
    }
  }
}
// 弹窗-start
.modal {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #000;
  opacity: 0.7;
}
.hmhl_text {
  position: fixed;
  left: calc(50% - 260px);
  top: calc(50% - 209px);
  opacity: 1;
  z-index: 1001;
  min-height: 418px;
  width: 515px;
  padding-bottom: 20px;
  &-container {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    transform: scale(0.85);
    .hmhl_text_close {
      position: absolute;
      right: 20px;
      top: 20px;
      height: 14px;
      width: 14px;
      z-index: 1002;
    }
  }
}
.pop_text {
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1001;
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 0 28px;
  text-align: left;
  border-radius: 8px;
  & p {
    padding: 0;
    margin: 0;
    line-height: 24px;
    text-indent: 2em;
    color: #333333 !important;
    font-size: 16px;
  }
  &_contain {
    padding-top: 20px;
  }
  &_title {
    color: #333333 !important;
    text-align: center;
    font-size: 20px !important;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    margin: 0;
  }

  &_desc {
    font-family: PingFangSC-Regular, PingFang SC;
  }
  &_signature {
    text-align: right;
    padding-top: 14px;
  }
}
// 弹窗-end
</style>
